import request from '@/api/request.js'


//
export function GetRemoteIPAddress() {
    return request({
        url: '/api/check/getremoteipaddress',
        method: 'get',
        data: {}
    })
}

// 
export function GetRandomGuid() {
    return request({
        url: '/api/check/getrandomguid',
        method: 'get',
        data: {}
    })
}